// extracted by mini-css-extract-plugin
module.exports = {"emptyBody":"ParticipationRequestsContainer_emptyBody__1-TPE"};